import React, { useEffect, useState } from "react";
import PLogo from "./PLogo";

/**
 * Price — Splash screen premium (style Apple)
 * S'affiche 1 seconde au chargement du site, puis fade out fluide.
 * Utilise sessionStorage pour ne pas rejouer à chaque navigation
 * dans la même session — comme le fait Apple sur ses landings.
 */
export default function PriceSplash() {
  const [visible, setVisible] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    // Skip splash if already shown in this session (évite le flash quand
    // l'user navigue entre les pages du site).
    if (sessionStorage.getItem("price_splash_shown") === "1") {
      setVisible(false);
      return;
    }
    const fadeTimer = setTimeout(() => setFadeOut(true), 1650);
    const hideTimer = setTimeout(() => {
      setVisible(false);
      sessionStorage.setItem("price_splash_shown", "1");
    }, 2000);
    return () => { clearTimeout(fadeTimer); clearTimeout(hideTimer); };
  }, []);

  if (!visible) return null;
  return (
    <div
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center transition-opacity duration-[350ms]"
      style={{
        background: "#FFF6EE",
        opacity: fadeOut ? 0 : 1,
        pointerEvents: fadeOut ? "none" : "auto",
      }}
      aria-hidden={fadeOut}
    >
      {/* Cercles décoratifs très légers */}
      <div className="pointer-events-none absolute -top-24 -left-16 h-72 w-72 rounded-full blur-3xl" style={{ background: "rgba(248,106,120,0.14)" }} />
      <div className="pointer-events-none absolute -bottom-24 -right-16 h-72 w-72 rounded-full blur-3xl" style={{ background: "rgba(248,106,120,0.10)" }} />

      <div className="relative flex flex-col items-center animate-splash-in">
        <PLogo size={110} />
        <div className="mt-6 font-[Outfit] text-[42px] font-black leading-none tracking-tight" style={{ color: "#1E0910" }}>
          Price
        </div>
        <div className="mt-1 text-[11px] font-black uppercase tracking-[0.28em]" style={{ color: "rgba(30,9,16,0.5)" }}>
          Covoiturage
        </div>
        <div className="mt-6 h-[2px] w-8 rounded-full" style={{ background: "#F86A78" }} />
        <div className="mt-6 font-[Outfit] text-[22px] font-black" style={{ color: "#1E0910" }}>
          Le covoiturage <span style={{ color: "#F86A78" }}>instantané</span> arrive…
        </div>
      </div>
    </div>
  );
}
